<template>
    <div>
        <div class="purchase-card" v-for="(item, index) in purchaseData" v-bind:key="index">
            <div class="purchase-remove-btn">
                <span
                    @click="$emit('remove', index)"
                    title="Remover Item"
                    class="material-icons"
                    v-if="!qrCodePath.length"
                >
                    delete
                </span>
            </div>
            <div class="purchase-content">
                <div class="purchase-header">
                    <h3 class="purchase-header-title">{{ item.name }}</h3>
                    <span class="purchase-header-price">{{ currencyFilter(item.transactionValue) }}</span>
                </div>
                <div>
                    <p class="purchase-description">{{ item.description }}</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { currencyFilter } from '@/utils/filters';
export default {
    name: 'purchaseItem',
    props: {
        purchaseData: {
            type: Array
        },
        qrCodePath: {
            type: String,
            default: ''
        }
    },
    methods: {
        currencyFilter
    }
};
</script>

<style scoped>
.purchase-card {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    padding: 20px 0px;
    border-bottom: 1px solid #dbdbdb;
    margin: 20px 0;
}
.purchase-remove-btn {
    margin-right: 10px;
    color: red;
    margin-top: -5px;
}
.purchase-remove-btn span {
    cursor: pointer;
}
.purchase-content {
    flex-grow: 1;
}
.purchase-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.purchase-header-title {
    color: #000000;
    font-weight: 700;
    font-size: 13px;
    line-height: 15px;
    margin: 0;
}
.purchase-header-price {
    font-weight: 700;
    font-size: 16px;
    line-height: 15px;
    color: #707070;
}
.purchase-description {
    font-weight: 400;
    font-size: 12px;
    line-height: 18px;
    color: #a5a5a5;
    white-space: pre-wrap;
    word-wrap: break-word;
    font-family: inherit;
}
@media screen and (max-width: 1262px) {
    .purchase-header {
        flex-direction: column-reverse;
        align-items: flex-start;
        gap: 10px;
    }
}
@media screen and (max-width: 768px) {
    .purchase-card {
        margin: 10px 0;
    }
}
</style>
